import getBreakpoint from "./breakpoints";
const navBtn = document.querySelector('#navBtn');
const navBtnText = document.querySelector('.navBtnText');
const nav = document.querySelector('#nav');
const body = document.querySelector('body');
const showChildren = document.querySelectorAll('.showChildren');
const showChildrenLen = showChildren.length;
const childNavs = document.querySelectorAll('.childNav');
const childNavsLen = childNavs.length;
const childNavLinks = document.querySelectorAll('.childNavLink');
const childNavLinksLen = childNavLinks.length;
const navLinks = document.querySelectorAll('.navLink');
const navLinksLen = navLinks.length;
let position;

if (navBtn) {

    function removeClasses(elements, length, classes) {
        for (let i = 0; i < length; i++) {
            if (elements[i].classList.contains(classes)) {
                elements[i].classList.remove(classes);
            }
        }
    }

    function closeMenu(position) {
        navBtn.classList.remove('is-active');
        nav.classList.remove('is-active');
        body.classList.remove('nav-is-active');
        console.log(position);
        // remove scroll position jump fix and put back to correct position
        body.style.top = '';
        window.scrollTo(0, position);

        body.classList.remove('no-scroll');
        navBtnText.innerHTML = 'Menu';
        removeClasses(childNavs, childNavsLen, 'is-active')
        removeClasses(showChildren, showChildrenLen, 'is-active')
    }

    navBtn.addEventListener('click', () => {
        if (!body.classList.contains('no-scroll')) {
            // get scroll position
            position = window.pageYOffset;
            body.classList.remove('smooth-scroll');
        } else {
            setTimeout( () => {
                // remove scroll position jump fix and put back to correct position
                body.style.top = '';
                window.scrollTo(0, position);
            }, 10);

            body.classList.add('smooth-scroll');
        }

        if (!navBtn.classList.contains('is-active')) {
            navBtnText.innerHTML = 'Close';
        } else {
            navBtnText.innerHTML = 'Menu';
        }
        navBtn.classList.toggle('is-active');
        nav.classList.toggle('is-active');
        body.classList.toggle('nav-is-active');
        body.classList.toggle('no-scroll');

        console.log(position);
        // keep scroll position to prevent jump
        body.style.top = `-${position}px`;
    })

    for (let i = 0; i < showChildrenLen; i++) {
        showChildren[i].addEventListener('click', (e) => {
            e.preventDefault();

            let breakpoint = getBreakpoint();

            if (breakpoint !== 'thumb') {
                if (showChildren[i].classList.contains('is-active')) {
                    showChildren[i].classList.remove('is-active')
                    showChildren[i].nextElementSibling.classList.remove('is-active')
                } else {
                    for (let j = 0; j < showChildrenLen; j++) {
                        if (showChildren[j].classList.contains('is-active')) {
                            showChildren[j].classList.remove('is-active')
                            showChildren[j].nextElementSibling.classList.remove('is-active')
                        }
                    }

                    showChildren[i].classList.add('is-active')
                    showChildren[i].nextElementSibling.classList.add('is-active')
                }
            } else {
                showChildren[i].classList.toggle('is-active');
                showChildren[i].nextElementSibling.classList.toggle('is-active');
            }

            for (let k = 0; k < childNavLinksLen; k++) {
                childNavLinks[k].addEventListener('click', closeMenu);
            }
        });
    }

    for (let j = 0; j < navLinksLen; j++) {
        navLinks[j].addEventListener('click', closeMenu);
    }
}
